import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamMarkingRequestSchema } from './schemas';

export const LEGACY_EXAM_MARKING_REQUEST_FIELDS = describeFields(LegacyExamMarkingRequestSchema, {
  id: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  dueDatetime: { widget: FieldWidget.DateTime },
  examSubject: { widget: FieldWidget.Text },
  examCode: {},
  examId: { displayField: 'examLabel' },
  examLabel: {},
  fileName: {},
  markerId: {},
  markerName: {},
  status: {},
  studentId: {},
  studentName: {},
});
